import { NavRoute } from '../shared/navigation/nav.route.interface';
import { getMainNavAdmin } from './nav-areas/admin-nav';
import { getMainNavMyOrg } from './nav-areas/my-organization-nav';
import { getMainNavSite } from './nav-areas/site-nav';
import { getMainNavOrg } from './nav-areas/orginization-nav';
import { getMainNavReports } from './nav-areas/reports-nav';
import { getMainNavUsers } from './nav-areas/users-nav';
import { getMainNavHelp } from './nav-areas/help-nav'
import { getSubNavUsers } from './nav-areas/user-sub-nav';
import { getSubNavOrg } from './nav-areas/orginization-sub-nav';
import { getSubNavSite } from './nav-areas/site-sub-nav';

export const getMainNavRoutes: () => NavRoute[] = function () {
	return [
		, getMainNavOrg()
		, getMainNavSite()
		, getMainNavMyOrg()
		, getMainNavReports()
        , getMainNavUsers()
		, getMainNavAdmin()
		, getMainNavHelp()

        , getSubNavOrg()
        , getSubNavSite()
        , getSubNavUsers()
	];
};
